// @flow

import {graphql} from '@apollo/react-hoc';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {CollapsibleLinkpile} from '@homeaway/react-linkpile';
import seoLinkpileQuery from '../../queries/seoLinkpileQuery';
import {makeRelativeUrl} from '../../utils/routerUtils';
import {media} from '../../utils/breakpoints';
import withSeoMetaData from '../withSeoMetaData/withSeoMetaData';

import type {State as ReduxState} from '../../reducers/index';
import type {SeoLinkpileResponseData} from '../../queries/seoLinkpileQuery';
import type {WithSeoMetaDataProps} from '../withSeoMetaData/withSeoMetaData';

import './SeoLinkpile.less';

type OwnProps = {
    canonicalLink: ?string
};

type StateProps = {
    isMobile: boolean,
    site: string
};

export type Props = OwnProps &
    WithSeoMetaDataProps &
    StateProps & {
        data: SeoLinkpileResponseData
    };

const mapStateToProps = (state: ReduxState): StateProps => ({
    isMobile: !media(state.viewport.breakpoint, {minWidth: 'SM_MIN'}),
    site: state.system.siteName
});

const mapGraphQLResponseToProps = (props) => {
    const {
        ownProps: {site, isMobile},
        data
    } = props;
    const {seoLinkpile, loading, error} = data;
    const defaultProps = {
        forceExpanded: true,
        categories: [],
        site,
        isMobile
    };

    if (loading || error || !seoLinkpile) {
        return defaultProps;
    }

    return {
        ...defaultProps,
        ...seoLinkpile
    };
};

export const queryOptions = ({
    seoData: {canonicalLink}
}: WithSeoMetaDataProps) => {
    const path = makeRelativeUrl(canonicalLink); // canonicalUrl is an absolute URL, we need relative decoded path

    return {
        variables: {
            path,
            isPathExists: !!path
        }
    };
};

export default compose(
    connect(mapStateToProps),
    withSeoMetaData,
    graphql(seoLinkpileQuery, {
        props: mapGraphQLResponseToProps,
        options: queryOptions
    })
)(CollapsibleLinkpile);
